import Page from "components/common/page/Page";

const AgricultureMaintenanceTypeHomePage = () => {
    return (
        <Page title="pages.agriculture.work.maintenance.type.home">
            <div>Agriculture Maintenance Type Form</div>
        </Page>
    );
};

export default AgricultureMaintenanceTypeHomePage;
